import { API_BASE, getAuthHeaders } from '../../utils/supabase/client';

export async function fetchSIJson<T>(path: string, init: RequestInit = {}, timeoutMs = 15000): Promise<{ response: Response; value: T }> {
 const timeout = AbortSignal.timeout(timeoutMs);
 const signal = init.signal ? AbortSignal.any([init.signal, timeout]) : timeout;
 let onAbort!: () => void;
 const cancelled = new Promise<never>((_, reject) => {
  onAbort = () => reject(timeout.aborted ? new Error('Chat loading timed out. Please retry.') : new DOMException('Aborted', 'AbortError'));
  if (signal.aborted) onAbort(); else signal.addEventListener('abort', onAbort, { once: true });
 });
 try {
  return await Promise.race([cancelled, (async () => {
   const headers = await getAuthHeaders(); signal.throwIfAborted();
   const response = await fetch(`${API_BASE}${path}`, { ...init, headers: { ...headers, ...init.headers }, signal });
   const value = await response.json() as T; signal.throwIfAborted();
   return { response, value };
  })()]);
 } finally { signal.removeEventListener('abort', onAbort); }
}
